import { createContext } from "react";
import useAttachmentsByLotId from "../hooks/data/useAttachmentsByLotId";

export interface ILotAttachmentsContext extends ReturnType<typeof useAttachmentsByLotId> {

};

const LotAttachmentsContext = createContext<ILotAttachmentsContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default LotAttachmentsContext